import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles.css'
import { AuthProvider } from './contexts/AuthContext'
import { I18nProvider } from './contexts/I18nContext';

// Get Memberstack public key from environment variables
const MEMBERSTACK_PUBLIC_KEY = import.meta.env.VITE_MEMBERSTACK_PUBLIC_KEY || 'pk_test_your_public_key_here'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider publicKey={MEMBERSTACK_PUBLIC_KEY}>
      <I18nProvider>
        <App />
      </I18nProvider>
    </AuthProvider>
  </React.StrictMode>,
)